import { gql } from "@apollo/client";

// ===== PUBLIC =====
export const HOME_FAQS_QUERY = gql`
  query HomeFaqs {
    homeFaqs {
      id
      question
      answer
      position
    }
  }
`;

export const LISTING_FAQS_QUERY = gql`
  query ListingFaqs($productType: String!, $metal: String) {
    listingFaqs(productType: $productType, metal: $metal) {
      id
      question
      answer
      productType
      metal
      position
    }
  }
`;

export const PRODUCT_FAQS_QUERY = gql`
  query ProductFaqs($productId: ID!) {
    productFaqs(productId: $productId) {
      id
      question
      answer
      position
    }
  }
`;

// ===== ADMIN =====
export const ADMIN_HOME_FAQS_QUERY = gql`
  query AdminHomeFaqs {
    adminHomeFaqs {
      id
      question
      answer
      position
      active
      createdAt
    }
  }
`;

export const ADMIN_LISTING_FAQS_QUERY = gql`
  query AdminListingFaqs {
    adminListingFaqs {
      id
      question
      answer
      productType
      metal
      position
      active
      createdAt
    }
  }
`;

export const ADMIN_PRODUCT_FAQS_QUERY = gql`
  query AdminProductFaqs($productId: ID!) {
    adminProductFaqs(productId: $productId) {
      id
      question
      answer
      position
      active
      createdAt
    }
  }
`;

export const ADMIN_UPSERT_HOME_FAQ_MUTATION = gql`
  mutation AdminUpsertHomeFaq(
    $id: ID
    $question: String!
    $answer: String!
    $position: Int
    $active: Boolean
  ) {
    adminUpsertHomeFaq(
      input: {
        id: $id
        question: $question
        answer: $answer
        position: $position
        active: $active
      }
    ) {
      faq {
        id
        question
        answer
        position
        active
      }
      errors
    }
  }
`;

export const ADMIN_DELETE_HOME_FAQ_MUTATION = gql`
  mutation AdminDeleteHomeFaq($id: ID!) {
    adminDeleteHomeFaq(input: { id: $id }) {
      success
      errors
    }
  }
`;

export const ADMIN_UPSERT_LISTING_FAQ_MUTATION = gql`
  mutation AdminUpsertListingFaq(
    $id: ID
    $productType: String!
    $metal: String
    $question: String!
    $answer: String!
    $position: Int
    $active: Boolean
  ) {
    adminUpsertListingFaq(
      input: {
        id: $id
        productType: $productType
        metal: $metal
        question: $question
        answer: $answer
        position: $position
        active: $active
      }
    ) {
      faq {
        id
        question
        answer
        productType
        metal
        position
        active
      }
      errors
    }
  }
`;

export const ADMIN_DELETE_LISTING_FAQ_MUTATION = gql`
  mutation AdminDeleteListingFaq($id: ID!) {
    adminDeleteListingFaq(input: { id: $id }) {
      success
      errors
    }
  }
`;

export const ADMIN_UPSERT_PRODUCT_FAQ_MUTATION = gql`
  mutation AdminUpsertProductFaq(
    $id: ID
    $productId: ID!
    $question: String!
    $answer: String!
    $position: Int
    $active: Boolean
  ) {
    adminUpsertProductFaq(
      input: {
        id: $id
        productId: $productId
        question: $question
        answer: $answer
        position: $position
        active: $active
      }
    ) {
      faq {
        id
        question
        answer
        position
        active
      }
      errors
    }
  }
`;

export const ADMIN_DELETE_PRODUCT_FAQ_MUTATION = gql`
  mutation AdminDeleteProductFaq($id: ID!) {
    adminDeleteProductFaq(input: { id: $id }) {
      success
      errors
    }
  }
`;
